import Immutable from 'immutable';
import { bufferClientLog, flushClientLogs } from '../bufferedLog';
import { CashinLog } from './CashinLog';

let debug_counter = 1;

export const logCashinOffer = ({ ticketId, offer }) => {
    bufferClientLog(
        ticketId,
        CashinLog({
            message: `${debug_counter++} Cashin offer snapshot`,
            data: CashinLogData({ ticketId, offer, transactionStatus: offer?.getIn(['activeTransaction', 'status']) })
        })
    );
};
export const logCashinOfferUpdate = ({ ticketId, offer, pushJsCashinSubscriptionId }) => {
    bufferClientLog(
        ticketId,
        CashinLog({
            message: `${debug_counter++} Cashin offer push`,
            data: CashinLogData({
                ticketId,
                offer,
                modified: offer?.get('modified'),
                transactionStatus: offer?.getIn(['activeTransaction', 'status']),
                pushJsCashinSubscriptionId
            })
        })
    );
};
export const logCashinDialogOpen = ({ ticketId, offer }) => {
    bufferClientLog(
        ticketId,
        CashinLog({
            message: `${debug_counter++} Cashin offer button click`,
            data: CashinLogData({ ticketId, offer, transactionStatus: offer?.getIn(['activeTransaction', 'status']) })
        })
    );
    flushClientLogs(ticketId);
};
export const logCashinTransactionStart = ({ ticketId, offer }) => {
    bufferClientLog(
        ticketId,
        CashinLog({
            message: `${debug_counter++} Cashin transaction start`,
            data: CashinLogData({ ticketId, offer, transactionStatus: offer?.getIn(['activeTransaction', 'status']) })
        })
    );
    flushClientLogs(ticketId);
};
export const logCashinTransactionResultConfirmed = ({ ticketId, offer, message }) => {
    bufferClientLog(
        ticketId,
        CashinLog({
            message: `${debug_counter++} Cashin transaction result confirmed: '${message}'`,
            data: CashinLogData({ ticketId, offer, transactionStatus: offer?.getIn(['activeTransaction', 'status']) })
        })
    );
    flushClientLogs(ticketId);
};

export const logCashinSubscriptionReset = ({ ticketId, offer, oldPushSequence, pushJsCashinSubscriptionId }) => {
    bufferClientLog(
        ticketId,
        CashinLog({
            message: `${debug_counter++} Cashin subscription reset`,
            data: CashinLogData({
                ticketId,
                offer,
                pushSequence: offer?.get('pushSequence'),
                oldPushSequence: oldPushSequence,
                pushJsCashinSubscriptionId
            })
        })
    );
};

export const logSetAutoCashinLimit = ({ ticketId, automaticTransactionLimit, offer }) => {
    bufferClientLog(
        ticketId,
        CashinLog({
            message: `${debug_counter++} Auto cashin limit changed`,
            data: CashinLogData({
                ticketId,
                offer,
                automaticTransactionLimit,
                transactionStatus: offer?.getIn(['activeTransaction', 'status'])
            })
        })
    );
    flushClientLogs(ticketId);
};
export const logCancelAutoCashinLimit = ({ ticketId, offer }) => {
    bufferClientLog(
        ticketId,
        CashinLog({
            message: `${debug_counter++} Auto cashin cancelled`,
            data: CashinLogData({
                ticketId,
                offer,
                automaticTransactionLimit: offer?.get('automaticTransactionLimit'),
                transactionStatus: offer?.getIn(['activeTransaction', 'status'])
            })
        })
    );
    flushClientLogs(ticketId);
};

function CashinLogData({ ticketId, offer = Immutable.Map(), ...extraData }) {
    return {
        ticketId,
        offer: {
            version: offer?.get('version'),
            amount: offer?.get('amount'),
            status: offer?.get('status'),
            pushSequence: offer?.get('pushSequence')
        },
        ...extraData
    };
}

export const logClosePickDialogOpen = ({ ticketId, offer }) => {
    bufferClientLog(
        ticketId,
        CashinLog({
            message: `${debug_counter++} Cashin closing: closing mode entered`,
            data: CashinLogData({ ticketId, offer, transactionStatus: offer?.getIn(['activeTransaction', 'status']) })
        })
    );
    flushClientLogs(ticketId);
};

export const logClosePickCheckbox = ({ ticketId, betId, offer, pick, enabled }) => {
    bufferClientLog(
        ticketId,
        CashinLog({
            message: `${debug_counter++} Cashin closing: clicked on ${
                enabled ? 'enabled' : 'disabled'
            } checkbox with betid: ${betId}`,
            data: ClosePickLogDataWithBetIds({
                ticketId,
                betId,
                offer,
                transactionStatus: offer?.getIn(['activeTransaction', 'status']),
                pick
            })
        })
    );
    flushClientLogs(ticketId);
};

export const logClosePickSubmitBegin = ({ ticketId, offer }) => {
    bufferClientLog(
        ticketId,
        CashinLog({
            message: `${debug_counter++} Cashin closing: transaction start`,
            data: CashinLogData({ ticketId, offer, transactionStatus: offer?.getIn(['activeTransaction', 'status']) })
        })
    );
    flushClientLogs(ticketId);
};

export const logClosePickSubmitDone = ({ ticketId, offer, error }) => {
    bufferClientLog(
        ticketId,
        CashinLog({
            message: `${debug_counter++} Cashin closing: submit start ${error ? 'failed' : 'succeeded'}`,
            data: CashinLogData({
                ticketId,
                offer,
                error,
                transactionStatus: offer?.getIn(['activeTransaction', 'status'])
            })
        })
    );
    flushClientLogs(ticketId);
};

export const logClosePickEventualsTotals = ({ ticketId, offer, error, response }) => {
    bufferClientLog(
        ticketId,
        CashinLog({
            message: `${debug_counter++} Cashin closing: evaluate-eventual-totals ${error ? 'failed' : 'succeeded'}`,
            data: CashinLogData({
                ticketId,
                offer,
                response: error || response,
                transactionStatus: offer?.getIn(['activeTransaction', 'status'])
            })
        })
    );
    flushClientLogs(ticketId);
};

function ClosePickLogDataWithBetIds({ ticketId, betId, offer = Immutable.Map(), ...extraData }) {
    return {
        ticketId,
        betId,
        offer: {
            version: offer?.get('version'),
            amount: offer?.get('amount'),
            status: offer?.get('status')
        },
        ...extraData
    };
}
